/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SskSigningFailureReason } from './SskSigningFailureReason';
export type SskSigningFailureReport = {
    sso_type: SskSigningFailureReport.sso_type;
    reason: SskSigningFailureReason;
    detail?: (string | null);
    app_id?: (string | null);
    extension_version?: (string | null);
    reference_id?: (string | null);
};
export namespace SskSigningFailureReport {
    export enum sso_type {
        SPLIT_SAML = 'split_saml',
        SPLIT_OIDC = 'split_oidc',
    }
}

